import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getUsers, getRegistrations, approveRegistration, rejectRegistration } from '../services/api';
import { getAdminInfo } from '../services/auth';
import CompanyManagement from './CompanyManagement';
import './UserManagement.css';

function UserManagement() {
  const [mainTab, setMainTab] = useState('benutzer');
  const [users, setUsers] = useState([]);
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState('users');

  const adminInfo = getAdminInfo();

  useEffect(() => {
    if (mainTab === 'benutzer' && activeTab === 'users') {
      loadUsers();
    } else if (mainTab === 'benutzer' && activeTab === 'registrations') {
      loadRegistrations();
    }
  }, [mainTab, activeTab]);

  const loadUsers = async () => {
    try {
      setLoading(true);
      const data = await getUsers();
      setUsers(data.users || []);
    } catch (err) {
      setError(err.message || 'Fehler beim Laden der Benutzer');
    } finally {
      setLoading(false);
    }
  };

  const loadRegistrations = async () => {
    try {
      setLoading(true);
      const data = await getRegistrations();
      setRegistrations(data.registrations || []);
    } catch (err) {
      setError(err.message || 'Fehler beim Laden der Registrierungen');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (registrationId, notes) => {
    try {
      await approveRegistration(registrationId, adminInfo?.id, notes);
      loadRegistrations();
    } catch (err) {
      setError(err.message || 'Fehler beim Genehmigen');
    }
  };

  const handleReject = async (registrationId, notes) => {
    try {
      await rejectRegistration(registrationId, adminInfo?.id, notes);
      loadRegistrations();
    } catch (err) {
      setError(err.message || 'Fehler beim Ablehnen');
    }
  };

  return (
    <div className="user-management">
      <h2>Benutzer &amp; Mandanten</h2>

      <div className="tabs main-tabs">
        <button
          className={mainTab === 'benutzer' ? 'active' : ''}
          onClick={() => setMainTab('benutzer')}
        >
          Benutzer
        </button>
        <button
          className={mainTab === 'companies' ? 'active' : ''}
          onClick={() => setMainTab('companies')}
        >
          Firmen/Mandanten
        </button>
      </div>

      {mainTab === 'companies' && (
        <CompanyManagement embedded />
      )}

      {mainTab === 'benutzer' && (
        <>
      <div className="tabs">
        <button
          className={activeTab === 'users' ? 'active' : ''}
          onClick={() => setActiveTab('users')}
        >
          Benutzer
        </button>
        <button
          className={activeTab === 'registrations' ? 'active' : ''}
          onClick={() => setActiveTab('registrations')}
        >
          Ausstehende Registrierungen ({registrations.length})
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <div className="loading">Lade Daten...</div>
      ) : activeTab === 'users' ? (
        <table className="admin-table">
          <thead>
            <tr>
              <th className="col-id">User-Nr (ID)</th>
              <th>Email</th>
              <th>Name</th>
              <th>Mandantennummer</th>
              <th>Firma</th>
              <th>Status</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center' }}>
                  Keine Benutzer gefunden
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id}>
                  <td className="col-id">{user.id}</td>
                  <td>{user.email}</td>
                  <td>{user.name || '-'}</td>
                  <td>{user.mandantennummer || '-'}</td>
                  <td>{user.company || '-'}</td>
                  <td>
                    <span className={`badge ${user.is_approved ? 'badge-success' : 'badge-warning'}`}>
                      {user.is_approved ? 'Genehmigt' : 'Ausstehend'}
                    </span>
                  </td>
                  <td>
                    <Link to={`/admin/users/${user.id}`} className="btn btn-secondary">
                      Details
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Firma</th>
              <th>Angefragt am</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {registrations.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center' }}>
                  Keine ausstehenden Registrierungen
                </td>
              </tr>
            ) : (
              registrations.map((reg) => (
                <tr key={reg.id}>
                  <td>{reg.email}</td>
                  <td>{reg.name || '-'}</td>
                  <td>{reg.company || '-'}</td>
                  <td>{new Date(reg.requested_at).toLocaleDateString('de-DE')}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn btn-success"
                        onClick={() => handleApprove(reg.id, '')}
                      >
                        Genehmigen
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleReject(reg.id, '')}
                      >
                        Ablehnen
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
        </>
      )}
    </div>
  );
}

export default UserManagement;






